import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    awards: [],
    award: null,
    links: null,
    meta: null,
    filter: {
      countryId: '',
      productId: '',
      type: '',
      keyword: '',
      status: '',
      time: [],
    },
    awardTypeOptions: [
      { value: 1, text: '公司殊榮' },
      { value: 2, text: '產品獎項' },
      { value: 3, text: '媒體肯定' },
    ],
  },

  mutations: {
    CLEAR_ALL(state) {
      state.awards = [];
      state.award = null;
    },
    SET_AWARDS(state, data) {
      state.awards = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_AWARD(state, data) {
      state.award = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setAward({ commit }, data) {
      commit('SET_AWARD', data);
    },

    find({ commit, state }) {
      let url = `/awards?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Award'));
          return response.body;
        })
        .then((response) => {
          commit('SET_AWARDS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/awards/${id}`)
        .then((response) => response.body)
        .then(typeAs('Award'))
        .then((item) => {
          commit('SET_AWARD', item);
        });
    },

    destroy(_, id) {
      return http(`/awards/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/awards/${id}`, { method: 'PUT', data })
        : http('/awards', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
